var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30.8572 45.4055L54 24.0001L30.8572 2.59471","stroke":"black","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M54 24L-4.29153e-06 24","stroke":"black","strokeWidth":"4","key":1})]);
}

ArrowRight.defaultProps = {"width":"57","height":"48","viewBox":"0 0 57 48","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
